import { render } from "./ResselerView.vue?vue&type=template&id=b1673d70&scoped=true"
import script from "./ResselerView.vue?vue&type=script&lang=js"
export * from "./ResselerView.vue?vue&type=script&lang=js"

import "./ResselerView.vue?vue&type=style&index=0&id=b1673d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1673d70"]])

export default __exports__